import { render } from "./Menu.vue?vue&type=template&id=35bbd505&scoped=true&ts=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=35bbd505&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_vue@3.3.11_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35bbd505"]])

export default __exports__